import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Formato de fecha USA (MM/DD/YYYY) pedido por el cliente para toda la app.
// Acepta Date, ISO, DD/MM/YYYY (Europamundo) o YYYYMMDD.
export function fmtDateUS(value) {
  if (!value) return '';
  if (!(value instanceof Date)) {
    const s = String(value).trim();
    let m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) return `${m[2]}/${m[1]}/${m[3]}`;
    m = s.match(/^(\d{4})(\d{2})(\d{2})$/);
    if (m) return `${m[2]}/${m[3]}/${m[1]}`;
    m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[2]}/${m[3]}/${m[1]}`;
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    value = d;
  }
  if (isNaN(value.getTime())) return '';
  return `${String(value.getMonth() + 1).padStart(2, '0')}/${String(value.getDate()).padStart(2, '0')}/${value.getFullYear()}`;
}
